module.exports = __webpack_public_path__ + "static/media/apple-products.bd2e68d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/apple-products.png
// module id = 2256
// module chunks = 0